import React from 'react';
import { useGoals } from '../../contexts/GoalsContext';
import { PERIOD_LABELS, UNIT_LABELS } from '../../utils/goals';

// Always-visible progress, right under the header, so the goal is present while
// reading rather than hidden behind a menu.
const GoalStrip = ({ onOpen }) => {
  const { goal, progress, daysInARow, readToday } = useGoals();

  if (!goal) {
    return (
      <button
        onClick={onOpen}
        className="w-full mb-6 px-4 py-3 rounded-lg border border-dashed text-sm font-lato text-heading hover:bg-light-gray focus-visible:bg-light-gray transition-colors"
        style={{ borderColor: 'var(--color-card-border)' }}
      >
        {daysInARow > 0
          ? `${daysInARow} day${daysInARow > 1 ? 's' : ''} in a row — set a reading goal`
          : 'Set a reading goal'}
      </button>
    );
  }

  const unit = UNIT_LABELS[goal.unit];
  const period = PERIOD_LABELS[goal.period];

  return (
    <button
      onClick={onOpen}
      className="w-full mb-6 p-4 rounded-lg border text-left transition-colors hover:bg-light-gray focus-visible:bg-light-gray"
      style={{ backgroundColor: 'var(--color-card-bg)', borderColor: 'var(--color-card-border)' }}
      aria-label="Open reading goal"
    >
      <div className="flex justify-between items-baseline mb-2 gap-3">
        <span className="text-sm font-medium font-lato text-heading">
          This {period}: {progress.done} / {progress.target} {unit}
        </span>
        <span className="text-sm font-lato shrink-0" style={{ color: 'var(--color-charcoal)', opacity: 0.7 }}>
          {progress.met ? 'Done ✓' : `${progress.remaining} to go`}
        </span>
      </div>

      <div className="w-full rounded-full h-2" style={{ backgroundColor: 'var(--color-light-gray)' }}>
        <div
          className="h-2 rounded-full transition-all duration-300"
          style={{
            width: `${progress.percent}%`,
            backgroundColor: progress.met ? 'var(--color-gold)' : 'var(--color-medium-green)'
          }}
        />
      </div>

      <p className="text-xs mt-2 font-lato" style={{ color: 'var(--color-charcoal)', opacity: 0.7 }}>
        {daysInARow > 0
          ? `${daysInARow} day${daysInARow > 1 ? 's' : ''} in a row${readToday ? '' : ' — read one verse to keep it'}`
          : 'Read a verse today to start a run'}
      </p>
    </button>
  );
};

export default GoalStrip;
